import { ActivityPluginRegistry } from "../../registry/ActivityPluginRegistry";
import { MessageTypes } from "../../../entities/ActivityTypes";
import { ActivityWhatsappCard } from "./ActivityWhatsappCard";

ActivityPluginRegistry.register({
  key: "1:3",
  matches: (item) => item.Entity === 1 && item.Type === MessageTypes.Whatsapp,
  Component: ActivityWhatsappCard
});
